import {
  Divider,
  Icon,
  SecondaryButton,
  useTranslation,
} from '@testsigma/atoms';

import { ConnectionFailureNote } from '@modules/salesforce/shared/components/connection-form/connection-failure-note';
import { ConnectionFormBody } from '@modules/salesforce/shared/components/connection-form/connection-form-body';

import { useCreateConnectionForm, useCreateConnection } from '../../../hooks';

import { ConnectionFormHeader } from './header/connection-form-header';
import { UserNameAndPasswordFormAction } from './footer/username-and-password';
import { OAuthFormActions } from './footer/oauth';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { SalesforceLoginMethod } from '@modules/salesforce/models';

const UserConnectionCreateForm = () => {
  const location = useLocation();
  const isGlobalConnection = location.pathname.includes(
    'settings/salesforce_connections',
  );
  const [isTestConnection, setIsTestConnection] = useState(false);
  const { t } = useTranslation();
  const {
    watch,
    handleSubmit,
    values,
    isValid,
    loginMethod,
    handleUpdateFormValue,
  } = useCreateConnectionForm();

  const {
    isConnecting,
    hasConnectionFailed,
    handleUsernamePasswordLogin,
    handleOAuthLogin,
    handleClose,
    testIsConnecting,
  } = useCreateConnection(isGlobalConnection, isTestConnection);

  const handleTestConnection = () => {
    setIsTestConnection(true);
  };

  useEffect(() => {
    if (!isTestConnection || !isValid) return;
    if (loginMethod === SalesforceLoginMethod.OAUTH) {
      handleSubmit(handleOAuthLogin)();
    } else if (loginMethod === SalesforceLoginMethod.USERNAME_PASSWORD) {
      handleSubmit(handleUsernamePasswordLogin)();
    } else {
      console.error('Unknown login method.');
    }
    setIsTestConnection(false);
  }, [isTestConnection]);

  const handleFormSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <form onSubmit={handleFormSubmit}>
      <header>
        <ConnectionFormHeader />
      </header>

      <Divider type='solid' />

      <main>
        <ConnectionFailureNote hasConnectionFailed={hasConnectionFailed} />

        <ConnectionFormBody
          watch={watch}
          values={values}
          handleUpdateFormValue={handleUpdateFormValue}
        />
      </main>

      <Divider type='solid' />

      <footer
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '10px',
        }}
      >
        <SecondaryButton
          className='ml-5'
          onClick={handleTestConnection}
          disabled={!isValid || testIsConnecting}
        >
          <>
            {testIsConnecting ? (
              <div className='flex gap-x-1.5 items-center'>
                <Icon className='text-base flex animate-spin' name='loader' />
                {t('connecting.button.label')}
              </div>
            ) : (
              t('test.connection')
            )}
          </>
        </SecondaryButton>
        <UserNameAndPasswordFormAction
          loginMethod={loginMethod}
          isConnecting={isConnecting}
          isTestConnecting ={testIsConnecting}
          isValid={isValid}
          handleLogin={handleSubmit(handleUsernamePasswordLogin)}
          handleClose={handleClose}
        />
        <OAuthFormActions
          loginMethod={loginMethod}
          isConnecting={isConnecting}
          isTestConnecting ={testIsConnecting}
          isValid={isValid}
          handleLogin={handleSubmit(handleOAuthLogin)}
          handleClose={handleClose}
        />
      </footer>
    </form>
  );
};

export { UserConnectionCreateForm };
